import { render, staticRenderFns } from "./DeliveryFormList.vue?vue&type=template&id=b192c078&scoped=true&"
import script from "./DeliveryFormList.vue?vue&type=script&lang=js&"
export * from "./DeliveryFormList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFormList.vue?vue&type=style&index=0&id=b192c078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b192c078",
  null
  
)

export default component.exports